// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD3gLS59gxLYxIZfAtk0VORrJabXEqF71U",
  authDomain: "react-router-sample-84f48.firebaseapp.com",
  projectId: "react-router-sample-84f48",
  storageBucket: "react-router-sample-84f48.appspot.com",
  messagingSenderId: "767297204707",
  appId: "1:767297204707:web:21e695ebc0166050a5b0d6",
  measurementId: "G-CHLCK89MVH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const storage = getStorage(app);
export const db = getFirestore(app);
